import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from 'store/store'
import { Image } from 'lib/graphql/storefront'

export interface FacilityType {
  id: string | number
  image: string
  name: string
  images: Array<Image>
  mapImage: Image
  content: string
  price: number
  approvalRequired: boolean
}

export interface FacilityListType {
  list: FacilityType[]
}

const initialState: FacilityListType = {
  list: [],
}

// Slice
const FacilityListSlice = createSlice({
  name: 'facility',
  initialState,
  reducers: {
    setFacilityList: (state, action: PayloadAction<FacilityType[]>) => {
      const { payload } = action
      state.list = payload
    },
  },
})

// Selectors
export const getFacilityListSelector = (state: RootState): FacilityType[] =>
  state.facilityList.list

// Actions
export const { setFacilityList } = FacilityListSlice.actions

// Reducers
export default FacilityListSlice.reducer
